// extracted by mini-css-extract-plugin
export default {"circularMenu":"circular-menu_circularMenu__u6CZf","menuButton":"circular-menu_menuButton__k3u4q","menuItem":"circular-menu_menuItem__Lp4wA"};